import { Routes } from '@angular/router';
import { ProfileFormComponent } from './components/profile-form/profile-form.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NeonDataComponent } from './components/neon-data/neon-data.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';

export const routes: Routes = [
  { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'profile', component: ProfileFormComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'neon-data', component: NeonDataComponent },
  { path: '**', redirectTo: 'sign-in' },
];
